module.exports = __webpack_public_path__ + "d50c09ed1fa113bc00eb34f07b95e5ea.svg";